import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { NotFound } from "../components/NotFound";
import LoaderPage from "../pages/Loader";
import { GlobalStyles } from "../globalStyle";

const HomePage = lazy(() => import("../pages/Home"));
const PortfolioPage = lazy(() => import("../pages/Portfolio"));
const ContactPage = lazy(() => import("../pages/Contact"));
const AwardsPage = lazy(() => import("../pages/Awards"));

export const Root = () => {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <Suspense fallback={<LoaderPage />}>
        <Routes>
          <Route element={<Navbar />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/awards" element={<AwardsPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
